import { defineComponent, computed, ref } from "vue"
import { Search } from "vant"
import styles from "./index.module.less"

export default defineComponent({
  name: "SearchBox",
  props: {
    searchConfig: Object
  },
  emits: ["search", "enter"],
  setup(props, { emit, expose }) {
    const search = ref()
    const searchRef = ref()

    const searchProps = computed(() => {
      return {
        class: [`h-100pct`, styles.searchPane],
        placeholder: "请输入关键字",
        ...props.searchConfig
      }
    })

    const onUpdate = (value) => {
      search.value = value
      emit("search", value)
    }

    //按下回车或者键盘上的搜索触发
    const onEnter = (value) => {
      search.value = value
      emit("enter", value)
    }

    expose({
      inst: searchRef
    })
    return () => {
      return (
        <div class={styles.search}>
          <Search
            modelValue={search.value}
            onUpdate:modelValue={onUpdate}
            onSearch={onEnter}
            {...searchProps.value}
            ref={searchRef}
          />
        </div>
      )
    }
  }
})
